// extracted by mini-css-extract-plugin
module.exports =  {"tertiary":"ButtonTertiary-module__tertiary___uwtzx"};